import { useCallback, useEffect } from "react";
import { getPopupDimensions, getQueryVariable } from "../utils/helper";

const useLoginInstagram = ({
  clientId,
  redirect_uri,
  onFailure,
  onSuccess,
  ...rest
}) => {
  const checkInstagramAuthentication = useCallback(
    (context) => {
      const { location } = context;
      if (window.location.pathname !== "/") return;
      if (!localStorage.getItem("isLoginIstagram")) return;
      if (location.search.includes("code")) {
        onSuccess(getQueryVariable(location, "code"));
        return true;
      } else if (location.search.includes("error")) {
        onFailure({
          error: getQueryVariable(location, "error"),
          error_reason: getQueryVariable(location, "error_reason"),
          error_description: getQueryVariable(location, "error_description"),
        });
        return true;
      }

      return false;
    },
    [onFailure, onSuccess]
  );

  const onCredentialsChanged = (popup, resolve, reject) => {
    const error = {
      error: "closed",
      error_reason: "oauth_canceled",
      error_description: "User canceled the authentication",
    };
    if (popup == null) {
      onFailure(error);
      return;
    }
    if (!resolve) {
      return new Promise((res, rej) => onCredentialsChanged(popup, res, rej));
    }
    let isFinished;
    try {
      isFinished = checkInstagramAuthentication(popup);
    } catch (err) {}

    if (isFinished) {
      popup.close();
    } else if (popup.closed) {
      onFailure(error);
    } else {
      setTimeout(() => onCredentialsChanged(popup, resolve, reject), 10);
    }
  };

  const oAuthSignIn = () => {
    const settings =
      "scrollbars=no,toolbar=no,location=no,titlebar=no,directories=no,status=no,menubar=no,";
    const popup = window.open(
      `https://api.instagram.com/oauth/authorize?client_id=${clientId}&redirect_uri=${redirect_uri}&scope=user_profile&response_type=code`,
      "_blank",
      `${settings}${getPopupDimensions({ width: 400, height: 800 })}`
    );
    onCredentialsChanged(popup);
  };

  useEffect(() => {
    checkInstagramAuthentication(window);
  }, [checkInstagramAuthentication]);

  return oAuthSignIn;
};

export default useLoginInstagram;
